import { severity } from "../lib/scores";

const Cell = ({ label, value, sub, sev, testid }) => (
  <div className={`cc-score ${sev ? `sev-${sev}` : ""}`} data-testid={testid}>
    <div className="cc-label">{label}</div>
    <div className="font-mono text-3xl font-semibold mt-1">{value ?? "—"}</div>
    {sub && <div className="text-xs text-muted-foreground mt-1">{sub}</div>}
  </div>
);

export const ScoreBoard = ({ s }) => (
  <div className="cc-grid" data-testid="score-board">
    <Cell testid="score-gcs" label="GCS" value={s.gcs} sub={s.gcs != null ? (s.gcs <= 8 ? "Severe - protect airway" : s.gcs <= 12 ? "Moderate" : "Mild / normal") : "Enter E V M"} sev={severity.gcs(s.gcs)} />
    <Cell testid="score-qsofa" label="qSOFA" value={s.qsofa} sub={s.qsofa >= 2 ? "High risk of poor outcome" : "of 3"} sev={severity.qsofa(s.qsofa)} />
    <Cell testid="score-sofa" label="SOFA" value={s.sofa} sub={`${s.sofa_entered} organ systems`} sev={severity.sofa(s.sofa)} />
    <Cell testid="score-apache" label="APACHE II" value={s.apache2} sub={s.apache2 != null ? `Mortality ${s.apache2_mortality} · ${s.apache2_entered}` : `${s.apache2_entered} params`} sev={severity.apache2(s.apache2)} />
    <Cell testid="score-shock-index" label="Shock Index" value={s.shock_index} sub={s.modified_shock_index ? `Modified SI ${s.modified_shock_index}` : "HR / SBP"} sev={severity.shock_index(s.shock_index)} />
    <Cell testid="score-map" label="MAP" value={s.map} sub="mmHg" sev={s.map != null ? (s.map < 65 ? "critical" : "ok") : null} />
    <Cell testid="score-pf" label="PaO2/FiO2" value={s.pf_ratio} sub={s.pf_ratio != null && s.pf_ratio < 300 ? "Hypoxaemic" : "mmHg"} sev={s.pf_ratio != null ? (s.pf_ratio < 200 ? "critical" : s.pf_ratio < 300 ? "warn" : "ok") : null} />
    <Cell testid="score-bmi" label="BMI" value={s.bmi} sub="kg/m²" />
  </div>
);
